const  conditionplustwo = [
    "Did you take Math and Physics (both of 100 Marks) in class 11?",
    "Did you score grade C or above in both Math and Physics in class 11?",
    "Did you score grade C or above in Physics in class 12?",
    "Did you score Grade C (overall) or above in class 11?",
    "Did you score Grade C (overall) or above in class 12?",
  ];
  export default conditionplustwo;